<template>
  <div class="footer">
    <div class="footer-copyright text-center py-3">
      <div class="center-xy-ab">
        &copy; <a href="https://bownetsoft.cn">https://bownetsoft.cn</a> 虹通软件版权所有&nbsp;&nbsp;&nbsp;&nbsp;支持邮件:&nbsp;<a href="mailto:support@bownetsoft.com">support@bownetsoft.com</a>&nbsp;&nbsp;&nbsp;&nbsp;粤ICP备2026052027号-1&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;<img class="d-inline-block mr-1" src="../assets/ygab.png" style="margin-right: 10px;">粤公网安备44010602015950
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style>

.footer {
  position: fixed;
  bottom: 0;
  height: 60px;
  width: 100%;
  background: #1DA1F2;
  z-index: 9999;
}

.center-xy-ab{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  white-space: nowrap;
}

a:link {
  color:black;
  text-decoration:none;
}

a:visited {
  color:black;
  text-decoration:none;
}

a:hover {
  color:black;
  text-decoration:none;
}

a:active {
  color:black;
  text-decoration:none;
}
</style>

